import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'map-view',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.less'],
  encapsulation: ViewEncapsulation.None
})

export class GoogleMapComponent {
  @Input() markers : google.maps.Marker[]|any[] = [];

  markerDetailsDrawerVisible = false;
  selectedMarker:any;

  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPositions: google.maps.LatLngLiteral[] = [];


  mapOptions: google.maps.MapOptions = {
    center: { lat: 40.866667, lng: 34.566667 },
    zoom: 2,
    disableDefaultUI: true,
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    styles: [{
      stylers: [{ saturation: -100, color: "#a5a5a5" }]
    }]
  };


  getMarkerOptions(marker:any): google.maps.MarkerOptions {
    if (marker.highlight) {
      const icon = {
        url: marker.icon, // url
        scaledSize: new google.maps.Size(75, 75), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(0, 0) // anchor
      };
      return {
        draggable: false,
        icon: icon,
        animation: google.maps.Animation.BOUNCE,
        zIndex: 100
      }
    }
    return {
      draggable: false,
      icon: marker.icon
    }
  }

  markerClickEvent(marker:any) {
    this.selectedMarker = marker;
    this.markerDetailsDrawerVisible = true;
  }

  close(): void {
    this.markerDetailsDrawerVisible = false;
  }

  getPicSource(url:any) {
    return "https://iris.wcoomd.org" + url;
  }

  goToLink(link:any) {
    window.open(link, "_blank");
  }

  goToUNODCLink(link:any) {
    window.open("https://www.unodc.org/unodc"+ link, "_blank");
  }
}
